import OccurrenceDetail from './occurrence_detail.coffee'

$(document).on 'turbolinks:load', ->
  new OccurrenceDetail().handler_events()